import React, { SyntheticEvent } from "react";
import {
  Autocomplete,
  Popper,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { Control, Controller } from "react-hook-form";
import Grid from "@mui/material/Grid2";
import { matchSorter } from "match-sorter";

import {
  AuthTrackerButton,
  AutoComplete,
  HomeHeaderBox,
  NoOptionTextStyle,
} from "../style/style";
import { ListOptions } from "../../../models/Master";
import { ReferralSearchPayload } from "../../../models/Referral";
import useMenuItem from "../../../hooks/useMenuItem";
import { NO_OPTIONS } from "../../../constants/ResponseMessage";
import { TextConstants } from "../../../constants/Patient";
import { isEmpty } from "lodash";
import { removeAccents } from "../../../utils";

export interface PropsFromState {
  serviceProviderList: ListOptions[];
  control: Control<ReferralSearchPayload, any>;
  handleAgencyChange: (
    _e: SyntheticEvent<Element, Event>,
    value: ListOptions
  ) => void;
  agencyProvider: ListOptions;
  setListType: (value: number) => void;
}
type AllProps = PropsFromState;

const HomeHeader: React.FC<AllProps> = ({
  control,
  serviceProviderList,
  handleAgencyChange,
  agencyProvider,
  setListType,
}) => {
  const { open, onOpen, onClose } = useMenuItem();
  const [alignment, setAlignment] = React.useState<string>(
    TextConstants.AUTH_TRACKER
  );
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setListType(newAlignment === TextConstants.AUTH_TRACKER ? 0 : 1);
    setAlignment(newAlignment);
  };
  return (
    <Grid container justifyContent="space-between" sx={HomeHeaderBox}>
      <Grid size={{ xs: 4 }}>
        <ToggleButtonGroup
          color="primary"
          value={alignment}
          exclusive
          onChange={handleChange}
          aria-label="Platform"
        >
          <ToggleButton
            sx={AuthTrackerButton}
            value={TextConstants.AUTH_TRACKER}
          >
            Auth Tracker
          </ToggleButton>
          <ToggleButton
            sx={AuthTrackerButton}
            value={TextConstants.PATIENT_LIST}
          >
            Patient List
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid>
        <Controller
          render={(field) => (
            <Autocomplete //TBD
              sx={AutoComplete}
              disabled={isEmpty(serviceProviderList)}
              options={serviceProviderList}
              forcePopupIcon
              value={agencyProvider}
              getOptionLabel={(option: any) => option.label}
              open={open}
              onOpen={() => onOpen()}
              onClose={() => onClose()}
              disableClearable
              filterOptions={(options: any, { inputValue }) => {
                const normalizedInput = removeAccents(inputValue);
                return matchSorter(options, normalizedInput, { keys: ["label"] });
              }}
              isOptionEqualToValue={(option, value) =>
                option.label === value.label
              }
              id="auto-complete"
              autoComplete
              clearIcon={""}
              onChange={handleAgencyChange}
              includeInputInList
              renderInput={(params: any) => {
                return (
                  <TextField
                    {...params}
                    {...field}
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                    }}
                  />
                );
              }}
              noOptionsText={
                <Typography variant="h4" align="center">
                  {NO_OPTIONS}
                </Typography>
              }
              PopperComponent={CustomPopper}
              renderOption={(props, option) => {
                return (
                  <Typography {...props} key={option.value}>
                    {option.label}
                  </Typography>
                );
              }}
            />
          )}
          name="providerId"
          control={control}
        />
      </Grid>
    </Grid>
  );
};

const CustomPopper: React.FC<React.ComponentProps<typeof Popper>> = (props) => (
  <Popper {...props} sx={NoOptionTextStyle} />
);

export default HomeHeader;